import { render, staticRenderFns } from "./leaddetails.vue?vue&type=template&id=9169e0a2"
import script from "./leaddetails.vue?vue&type=script&lang=js"
export * from "./leaddetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports